import { useRef, useState } from 'react';
import { TurnstileInstance } from '@marsidev/react-turnstile';

export function useTurnstile() {
  const turnstileRef = useRef<TurnstileInstance>(null);
  const tokenRef = useRef<string | null>(null);
  const [widgetError, setWidgetError] = useState<string | null>(null);

  const getToken = (): Promise<string | null> => {
    const token = tokenRef.current;
    tokenRef.current = null;
    return Promise.resolve(token);
  };

  const reset = () => {
    tokenRef.current = null;
    setWidgetError(null);
    turnstileRef.current?.reset();
  };

  const widgetProps = {
    ref: turnstileRef,
    siteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY || '',
    options: {
      execution: 'render' as const,
      appearance: 'interaction-only' as const,
    },
    onSuccess: (token: string) => {
      tokenRef.current = token;
      setWidgetError(null);
    },
    onExpire: () => {
      tokenRef.current = null;
    },
    onError: () => {
      tokenRef.current = null;
      setWidgetError('Security check failed, please refresh and try again');
    },
    onTimeout: () => {
      tokenRef.current = null;
      setWidgetError('Security check timed out, please try again');
    },
  };

  return { getToken, reset, widgetProps, widgetError };
}
